<template>
  <div class="h-full fb fb-col">
    <div
      class="data-box-title fb font-28 mr-60 ml-32 h-40"
      v-if="courseSummarySorted.length"
    >
      <div
        class="data-box-title-item item-flex-1 mt-6 center"
        v-for="(st, index) in sortList"
        :key="st.key"
        @click="sortPopData(st.key)"
        :class="
          sort.key === st.key
            ? sort.tendancy
              ? sort.tendancy === 1
                ? 'up'
                : 'down'
              : ''
            : ''
        "
        ><span class="sort-name">{{ st.name }}</span>
        <span class="column-sorter font-24" v-show="index !== 0">
          <i class="sort-caret ascending"></i>
          <i class="sort-caret descending"></i>
        </span>
      </div>
    </div>
    <div class="relative h-340" v-else>
      <common-empty content="暂无数据"></common-empty>
    </div>
    <div class="item-flex-1 mt-6 scroll">
      <md-list class="m-0-16 mb-16 bd-radio-8 hidden" arrow>
        <md-list-item
          v-for="(item, index) in courseSummarySorted"
          :key="index"
          @click="handlerClickItem(item)"
        >
          <template #title>
            <div class="font-34 font-bold fb fb-cross-center text-center">
              <span class="item-flex-1">{{
                filterName(item.studentName, 4)
              }}</span>
              <span class="item-flex-1">{{ item.attendanceTimes }}</span>
              <span class="item-flex-1">{{ item.abnormalBehaviorTimes }}</span>
            </div>
          </template>
        </md-list-item>
      </md-list>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonEmpty from './commonEmpty'
import { filterName, deepCopy } from '@/utils/comUtils'

export default {
  mixins: [mixin],
  props: {
    recordList: {
      type: Array,
      default: () => []
    },
    currentClass: {
      type: Object,
      default: () => {}
    }
  },
  components: { commonEmpty },
  data() {
    return {
      filterName,
      showPop: false,
      sort: {
        key: null,
        tendancy: 0
      },
      sortList: [
        {
          name: ' ',
          key: ''
        },
        {
          name: '上课次数',
          key: 'attendanceTimes'
        },
        {
          name: '异常次数',
          key: 'abnormalBehaviorTimes'
        }
      ]
    }
  },
  computed: {
    courseSummarySorted() {
      const { tendancy, key } = this.sort
      if (key) {
        const list = deepCopy(this.recordList).sort((prev, next) => {
          return tendancy > 0 ? prev[key] - next[key] : next[key] - prev[key]
        })
        return list
      }
      return this.recordList
    }
  },
  watch: {},
  mounted() {},
  methods: {
    sortPopData(sortKey) {
      let { tendancy, key } = this.sort
      const changeKey = sortKey !== key
      if (changeKey) {
        key = sortKey
      }
      if (!tendancy || changeKey) {
        tendancy = 1
      } else if (tendancy === 1) {
        tendancy = -1
      } else {
        tendancy = 0
        key = null
      }
      this.sort = {
        tendancy,
        key
      }
    },
    handlerClickItem(item) {
      this.$router.push({
        path: `/behavior/detail`,
        query: {
          studentDetail: JSON.stringify({
            studentDingId: item.studentDingId || '',
            studentName: item.studentName || '',
            name: item.studentName || '',
            studentNo: item.studentNo || '',
            classDingId: this.currentClass.classDingId || '',
            className: this.currentClass.className || ''
          }),
          type: 2
        }
      })
    }
  }
}
</script>

<style lang="scss">
.data-box {
  margin-top: 10px;
  padding: 0 16px;
  &-title {
    &-item {
      text-align: center;
      padding: 10px 0;
      &.highlight {
        background: #fff;
        border-radius: 4px 4px 0 0;
      }
      .column-sorter {
        width: 12px;
        height: 12px;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        vertical-align: middle;
        cursor: pointer;
        overflow: initial;
        position: relative;
        .sort-caret {
          width: 0;
          height: 0;
          border: 4px solid transparent;
          position: absolute;
          left: 2px;
          &.ascending {
            border-bottom-color: rgba(23, 26, 29, 0.24);
            top: -5px;
          }
          &.descending {
            border-top-color: rgba(23, 26, 29, 0.24);
            bottom: -1px;
          }
        }
      }
      &.up {
        .sort-caret.ascending {
          border-bottom-color: #006afe;
        }
        .sort-name {
          color: #006afe;
        }
      }
      &.down {
        .sort-caret.descending {
          border-top-color: #006afe;
        }
        .sort-name {
          color: #006afe;
        }
      }
    }
  }
}
</style>
